import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'general-system-info-panel',
  templateUrl: './general-system-info.component.html',
  styleUrls: ['./general-system-info.component.css']
})
export class GeneralSystemInfoComponent {
  @Input() id;
  @Input() header = '';
  @Input() visible = false;
  @Input() yearDataDisplayed;
  @Input() collapsed = false;
  @Input() systemGeneralInfo = null;
  @Output() collapsedChange: EventEmitter<boolean>;

  constructor() {
    this.collapsedChange = new EventEmitter<boolean>();
  }

  onClick() {
    this.collapsedChange.emit(!this.collapsed);
  }
}



// WEBPACK FOOTER //
// ./src/app/profile/panels/general-system-info/general-system-info.component.ts